/* eslint-disable no-unused-vars */
import { ReactNode } from 'react'
import { IndexRouteObject } from 'react-router-dom'

export interface LayoutProps {
  children: ReactNode
}

export interface optionSelect {
  value: number | string | undefined
  label: ReactNode
}

export interface routerType {
  element?: React.ReactNode
  path?: IndexRouteObject['path']
  permission?: any
  layoutSetting? : boolean
}

export interface magazineType {
  app_name: string
  id: string
}

export interface paramsGet{
  page?: number,
  per_page?: number,
  keyword?: string,
  app_id: string,
  device_token?: string,
  is_get_future_magazine?: number,
  period_month?: number
}

export enum OS_TYPE {
  IOS = 1,
  ANDROID = 2,
  WEB = 3,
}